var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "d-flex flex-row" }, [
    _c(
      "button",
      {
        staticClass: "btn btn-sm",
        class: { "btn-primary": _vm.liked, "btn-secondary": !_vm.liked },
        attrs: { type: "button" },
        on: {
          click: function($event) {
            return _vm.$emit("like", !_vm.liked)
          }
        }
      },
      [
        _c("icon-component", { attrs: { icon: "fa-thumbs-up" } }),
        _vm._v("\n    " + _vm._s(_vm.list.length) + "\n  ")
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }